import React from "react";
import PeopleIcon from '@material-ui/icons/People';
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer } from "recharts";
import CardWithIcon from '../CardWithIcon';
import {GRAPH_COLORS, labelFormatter} from "../Constants";

const Users = ({ net, trends, expanded = false }) => {
    return (
        expanded ?
            <ResponsiveContainer width="100%" height={250}>
                <LineChart width={500} data={trends}
                           margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip labelFormatter={labelFormatter} />
                    <Legend verticalAlign="top" />
                    <Line type="monotone" dataKey="users" stroke={GRAPH_COLORS.line1} />
                </LineChart>
            </ResponsiveContainer>:
            <CardWithIcon
                to="/dashboard/site"
                icon={PeopleIcon}
                title="New Store Users"
                subtitle={net}
            />
    )
};

export default Users;